export default __webpack_public_path__ + "static/media/EternalBeings_Logo.a815b97f.svg";